// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"48":"8715218f6d5ee725efd3","60":"e76c09c7bf8f54c22423","232":"945a5c880a68a7f611a8","802":"48d1c18a728049511e90"}[chunkId] + ".js";
};